import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../utils/api'

export default function ResetPassword() {
    const { token } = useParams()
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState('')

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (password !== confirmPassword) {
            alert('Passwords do not match')
            return
        }
        setLoading(true)
        setStatus('Updating...')
        try {
            const res = await api.resetPassword(token as string, password)
            if (res.success) {
                alert('Success! Password has been reset.')
                window.location.href = '/login'
            } else {
                setStatus('Error: ' + (res.message || 'Reset failed'))
            }
        } catch (err) {
            setStatus('Error: Something went wrong')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div style={{ padding: '50px', background: '#f0f0f0', minHeight: '100vh', textAlign: 'center', color: '#000' }}>
            <div style={{ maxWidth: '400px', margin: '0 auto', background: '#fff', padding: '30px', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
                <h1 style={{ fontSize: '24px', marginBottom: '20px' }}>RESET PASSWORD FORM</h1>
                <p style={{ marginBottom: '20px' }}>Token: {token?.substring(0, 5)}...</p>
                
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '15px', textAlign: 'left' }}>
                        <label style={{ display: 'block', marginBottom: '5px' }}>New Password</label>
                        <input 
                            type="password" 
                            style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div style={{ marginBottom: '20px', textAlign: 'left' }}>
                        <label style={{ display: 'block', marginBottom: '5px' }}>Confirm Password</label>
                        <input 
                            type="password" 
                            style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        disabled={loading}
                        style={{ width: '100%', padding: '12px', background: 'blue', color: '#fff', border: 'none', cursor: 'pointer' }}
                    >
                        {loading ? 'Processing...' : 'RESET NOW'}
                    </button>
                </form>

                {status && <p style={{ marginTop: '20px', color: status.startsWith('Error') ? 'red' : 'green' }}>{status}</p>}
                
                <div style={{ marginTop: '20px' }}>
                    <a href="/login" style={{ color: 'blue' }}>Back to Login</a>
                </div>
            </div>
        </div>
    )
}
